import { render, staticRenderFns } from "./LabFormContent.vue?vue&type=template&id=4d3a9c14"
import script from "./LabFormContent.vue?vue&type=script&lang=js"
export * from "./LabFormContent.vue?vue&type=script&lang=js"
import style0 from "./LabFormContent.vue?vue&type=style&index=0&id=4d3a9c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports